import React from 'react';
export function Seal({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 200 200" className={className} role="img" aria-label="Republic: access, transparency, choice, control" data-id="element-34" data-mp="3ekrij2xnizte">
      <defs data-id="element-35" data-mp="2zwmztyylmoam">
        <path id="seal-arc-top" d="M 100 100 m -78 0 a 78 78 0 1 1 156 0" fill="none" data-id="element-36" data-mp="2zv3j67916b8b" />
        <path id="seal-arc-bottom" d="M 100 100 m 74 0 a 74 74 0 1 1 -148 0" fill="none" data-id="element-37" data-mp="34twm55qoyju8" />
      </defs>
      <circle cx="100" cy="100" r="96" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" data-id="element-38" data-mp="2qu5cfh77jpm1" />
      <circle cx="100" cy="100" r="62" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" data-id="element-39" data-mp="2vv1gpvvh1drz" />
      <text fontSize="14" letterSpacing="4" fill="currentColor" fontFamily="'DM Sans', sans-serif" data-id="element-40" data-mp="2gyany5gaz0bc">
        <textPath href="#seal-arc-top" startOffset="50%" textAnchor="middle" data-id="element-41" data-mp="2lxx0sds7yejm">
          ACCESS · TRANSPARENCY
        </textPath>
      </text>
      <text fontSize="14" letterSpacing="4" fill="currentColor" fontFamily="'DM Sans', sans-serif" data-id="element-42" data-mp="k3o28clfs44x">
        <textPath href="#seal-arc-bottom" startOffset="50%" textAnchor="middle" data-id="element-43" data-mp="3bbajfi90s0yk">
          CONTROL · CHOICE
        </textPath>
      </text>
      <text x="100" y="128" textAnchor="middle" fontSize="76" fill="currentColor" fontFamily="'Playfair Display', serif" data-id="element-44" data-mp="3l3onihnkljnw">
        R
      </text>
    </svg>;
}